import { collection, limitToLast, onSnapshot, orderBy, query } from "firebase/firestore";
import { firestore } from "../../../configs/FirebaseConfig";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_CHAT_SESSIONS_TABLE, FIRESTORE_REGIONS_TABLE } from "../../../constants/FirestoreConstant";
import { COMPANY_COUNTRY_CODE } from "../../../constants/CompanyConstants";

const INITIAL_MESSAGE_LIMIT = 50;

export function useChatMessages(chatId, messageLimit = INITIAL_MESSAGE_LIMIT) {
  const { data, error } = useSWRSubscription(
    chatId ? ["chatMessages", chatId, messageLimit] : null,
    (key, { next }) => {
      const messagesQuery = query(
        collection(
          firestore,
          `${FIRESTORE_REGIONS_TABLE}/${COMPANY_COUNTRY_CODE}/${FIRESTORE_CHAT_SESSIONS_TABLE}/${chatId}/messages`,
        ),
        orderBy("createdAt", "asc"),
        limitToLast(messageLimit),
      );

      const unsubscribe = onSnapshot(
        messagesQuery,
        (snapshot) => {
          const messages = snapshot.docs.map((messageDoc) => ({ ...messageDoc.data(), id: messageDoc.id }));
          next(null, messages);
        },
        (error) => {
          next(error, null);
        },
      );

      return () => unsubscribe();
    },
  );

  return {
    data,
    error,
    loading: chatId ? !data && !error : false,
    hasMore: !!data && data.length >= messageLimit,
  };
}

export { INITIAL_MESSAGE_LIMIT };
